// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"55":"3dc12ed3","210":"5b56fdf8","304":"7c116cb4","320":"e26edaab","508":"b910d15f","945":"f1485eb9"}[chunkId] + ".css";
};